import React from "react";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BoxContainer, IconContainer } from "./calendar-weekly-event.style";
import MySheetLeaveIcon from "@iconify/icons-mdi/bag-personal";
import MySheetIcon from "@iconify/icons-mdi/clipboard-text-clock-outline";
import { InlineIcon } from "@iconify/react";
import {
  MyTimesheetCalendarTooltip,
  MyTimesheetStyledCalendarTooltip,
} from "my-timesheet/components";

interface CalendarWeeklyEventProps {
  event: {
    id?: string;
    start: string | Date;
    end: string | Date;
    title?: string;
    projectName?: string;
    clientName?: string;
    [key: string]: any;
  };
}

export const MyTimesheetCalendarWeeklyEvent: React.FC<
  CalendarWeeklyEventProps
> = ({ event }) => {
  const theme = useTheme();

  const start = moment(event.start).format("HH:mm");
  const end = moment(event.end).format("HH:mm");

  const isLeaveEvent = event?.id?.startsWith("leave-");

  return (
    <MyTimesheetStyledCalendarTooltip
      title={<MyTimesheetCalendarTooltip event={event} />}
      placement="top"
    >
      <BoxContainer>
        {!isLeaveEvent && (
          <IconContainer>
            <InlineIcon icon={MySheetIcon} width="60px" height="60px" />
          </IconContainer>
        )}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
        >
          <Box>
            <Typography
              variant="body2"
              noWrap
              style={{
                fontSize: "10px",
                lineHeight: "normal",
                color: isLeaveEvent
                  ? theme.palette.white.main
                  : theme.palette.primary.main,
              }}
            >
              {event?.title}
            </Typography>
            <Typography
              variant="body2"
              noWrap
              style={{
                lineHeight: "normal",
              }}
            >
              {event?.projectName}
            </Typography>
            {isLeaveEvent && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <IconContainer>
                  <InlineIcon
                    icon={MySheetLeaveIcon}
                    width="60px"
                    height="60px"
                  />
                </IconContainer>
              </Box>
            )}
            <Typography
              variant="body2"
              noWrap
              style={{
                color: theme.palette.darkBase.main,
                fontSize: "10px",
                lineHeight: "normal",
              }}
            >
              {event?.clientName}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            noWrap
            style={{
              fontSize: "10px",
              lineHeight: "normal",
              color: isLeaveEvent
                ? theme.palette.white.main
                : theme.palette.gray60.main,
            }}
          >
            {start} - {end}
          </Typography>
        </Box>
      </BoxContainer>
    </MyTimesheetStyledCalendarTooltip>
  );
};

export default MyTimesheetCalendarWeeklyEvent;
